/**
 * @desc 平台站点-查询站点详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformSiteShopResponseDto>;
export function request(shopKey: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platformSiteShop/details/${shopKey}`, {
      method: "GET",

      ...options,
    }),
  );
}
